import { render, staticRenderFns } from "./SiUserAvatar.vue?vue&type=template&id=4353e7cd&scoped=true&lang=html&"
import script from "./SiUserAvatar.vue?vue&type=script&lang=js&"
export * from "./SiUserAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4353e7cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
